export function visibleSteps () {
  return Object.keys(predefinedStepsInfo())
}

export function predefinedWorkspaces () {
  const pipelines = require('../config/pipelines.json')
  const serve = require('../config/pipelines.serve.json')
  if (process.env.VUE_APP_DEBUG) {
    const dev = require('../config/pipelines.dev.json')
    return [...pipelines, ...dev, ...serve].filter(x => x.enable)
  } else {
    return [...pipelines, ...serve].filter(x => x.enable)
  }
}

export function predefinedStepsInfo () {
  return {
    ocr_text: {
      automation: true
    },
    raw_html: {
      automation: true
    },
    convert_html: {
      automation: true
    },
    image_view: {
      automation: true
    },
    preprocess: {
      automation: false
    },
    preprocess_s: {
      automation: false
    },
    structurize: {
      automation: true
    },
    topic_classification: {
      automation: false
    },
    topic: {
      automation: false
    },
    entity_extraction: {
      automation: false
    },
    entity_extraction2: {
      automation: false
    },
    relation_extraction: {
      automation: false
    },
    table_analysis: {
      automation: false
    },
    table_automation: {
      automation: true
    },
    field_extraction: {
      automation: true
    },
    ocr_text_image: {
      automation: true
    },
    ocr_text_detection: {
      automation: false
    },
    ocr_text_recognition: {
      automation: false
    },
    ocr_tag_text: {
      automation: false
    },
    ocr_object_detection: {
      automation: false
    },
    information_summary: {
      automation: true
    },
    text_nlp_summary: {
      automation: true
    },
    full_text_classify: {
      automation: false
    },
    full_text_labeling: {
      automation: true
    },
    json_view: {
      automation: true
    },
    tag_region: {
      automation: false
    },
    tag_region2: {
      automation: false
    },
    classify_table: {
      automation: false
    },
    extraction_review: {
      automation: true
    },
    table_structure_recognition: {
      automation: false
    },
    named_entity_recognition: {
      automation: false
    },
    vocab_diff: {
      automation: false
    },
    layout: {
      automation: false
    },
    bank_entity_extraction: {
      automation: false
    },
    ocr_editor: {
      automation: true
    },
    text_compare: {
      automation: true
    },
    text_relation: {
      automation: false
    }
  }
}

export function predefinedWorkspaceTypes () {
  return predefinedWorkspaces().map(x => x.name)
}

export function isPipelineReadyForServing (name) {
  const pipeline = require('./pipelines.json').find(x => x.name === name)
  const stepExInfo = predefinedStepsInfo()
  return pipeline.steps.every(x => !!x.default || !!x.pretrained || stepExInfo[x.model].automation)
}

export function exportServingPipeline (name) {
  const pipeline = require('./pipelines.json').find(x => x.name === name)
  pipeline.serving = true
  const servingPipelines = require('./pipelines.serve.json').filter(x => x.name !== name)
  servingPipelines.push(pipeline)
  const fs = require('fs')
  fs.writeFile('./pipelines.serve.json', JSON.stringify(servingPipelines))
}

export function predefinedStepsConfig (predefinedType) {
  return predefinedWorkspaces().find(x => x.name === predefinedType).steps
}

export function isTrainingStep (config) {
  if (!config) return false
  if (config.automation) {
    return false
  } else if (config.training) {
    return true
  } else if (predefinedStepsInfo()[config.ui].automation) {
    return false
  } else {
    return !config.lock
  }
}

function checkFlag (metadata, step, flagname) {
  const flags = metadata[step]
  if (!flags) return false
  return !!flags[flagname]
}

function getProp (metadata, step, name) {
  const flags = metadata[step]
  if (!flags) return null
  return flags[name] || null
}

function checkPrerequisite (config, subdirs) {
  const keys = Object.keys(config).filter(x => x.startsWith('input'))
  if (keys.length === 0) { return true }
  for (const key of keys) {
    const pattern = config[key]
    const any_match = subdirs.some(subdir => subdir.match(pattern))
    if (!any_match) { return false }
  }
  return true
}

export function keyStatus (stepConfig, file) {
  const stepInfo = predefinedStepsInfo()[stepConfig.ui]
  const automation = (stepInfo && stepInfo.automation && !stepConfig.training) || stepConfig.automation
  return {
    processing: checkFlag(file.metadata, stepConfig.name, 'processing'),
    prerequisite: checkPrerequisite(stepConfig, file.filenames.concat(file.foldernames || [])),
    signoff: automation || !!stepConfig.pretrained || checkFlag(file.metadata, stepConfig.name, 'signoff'),
    validation:
            checkFlag(file.metadata, stepConfig.name, 'validation') &&
            checkFlag(file.metadata, stepConfig.name, 'signoff'),
    evaluation: (file.evaluation || {})[stepConfig.name] || {},
    weight: getProp(file.metadata, stepConfig.name, 'weight')
  }
}
